import request from '@/utils/request'
import config from '@/config'

export function getSalesforceToken() {
  return request(
    {
      path: '/self-serve/sf-token/merchant',
      method: 'POST',
      customBaseURL: config.apiBaseUrl,
    },
    {
      options: {
        hideMessage: true,
      },
    }
  )
}
